import { render, staticRenderFns } from "./resourceType.vue?vue&type=template&id=e7c6a064&"
import script from "./resourceType.vue?vue&type=script&lang=js&"
export * from "./resourceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports